import { defineComponent as _defineComponent } from 'vue'
import { IEvent } from '@/enitites/event'
import { ModalWrapper } from '@/shared/ui/modals'
import { ref } from 'vue'
import PurchaseTicketsInterface from '@/features/tickets/ui/PurchaseTicketsInterface.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseTicketsButton',
  props: {
    event: null
  },
  setup(__props: any) {



const isShowModal = ref(false)

return { __sfc: true,isShowModal, ModalWrapper, PurchaseTicketsInterface }
}

})